import { render, staticRenderFns } from "./GiftForm.vue?vue&type=template&id=4322be49&scoped=true&"
import script from "./GiftForm.vue?vue&type=script&lang=js&"
export * from "./GiftForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4322be49",
  null
  
)

export default component.exports